import React from 'react'
import {
  faCirclePlus,
  faPlusCircle,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { ProductImage } from 'app/common/Common'
import { get } from 'client/utils/api-routes.util'
import { colors } from 'pixel-base'
import {
  $DCprimaryColor,
  DcDiv,
  DcFlexBox,
  DcInput,
  PixelCurrency,
  PixelFlexBox,
  PixelIcon,
} from 'pixel-base'
import styled, { css } from 'styled-components'

const LineItem = (props) => {
  const {
    item,
    editing,
    addLineItem,
    index,
    removeLineitem,
    updateItem,
    setNewProduct,
    localLineItems,
  } = props
  const [products, setProducts] = React.useState<any>([])
  const handleNegativePrice = (e) => {
    if (e.key === '-') {
      e.preventDefault()
    }
  }

  const handleSearch = (query) => {
    get(`/products/lineitems?search=${query}`).subscribe((res: any) => {
      setProducts([
        {
          image: null,
          product_name: query,
          price: 1,
          stock_quantity: 1,
          line_item_id: 0,
          quantity: 1,
          product_id: 0,
          variation_id: 0,
          sku: `custom_${query}`,
          custom: 'Custom',
        },
        ...res.response,
      ])
    })
  }
  const handleAddProduct = (product) => {
    setNewProduct(product, index)
  }

  return (
    <LineItemRow is_deleted={item.is_deleted}>
      <LineInfoItem width="50%">
        {editing && (
          <LineItemActions>
            <LineItemAction
              onClick={() => {
                addLineItem(index + 1, 'between')
              }}
            >
              <PixelIcon color="green" icon={faPlusCircle} />
            </LineItemAction>
            {item.is_deleted ? (
              <></>
            ) : (
              <LineItemAction
                onClick={() => {
                  if (item.product_id === -1 || item.product_id === 0) {
                    if (localLineItems?.length > 1) {
                      removeLineitem(item, index)
                    }
                  } else {
                    removeLineitem(item, index)
                  }
                }}
              >
                <PixelIcon color={colors.danger} icon={faTrash} />
              </LineItemAction>
            )}
          </LineItemActions>
        )}
        <Col style={{ width: '100%' }}>
          {item.product_id !== -1 && (
            <Row style={{ justifyContent: 'flex-start' }}>
              <Col>
                <ProductImage
                  style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '10%',
                    objectFit: 'cover',
                    marginRight: '10px',
                  }}
                  path={item.image}
                />
              </Col>
              <Col>
                <ProductName>
                  {editing ? (
                    <>
                      {item.product_id === 0 ? (
                        <>
                          <div>
                            <DcInput
                              isShowLabel={false}
                              as={item.product_id === 0}
                              placeholder="Product Name"
                              value={item.name}
                              onChange={(e) => {
                                updateItem(
                                  {
                                    ...item,
                                    name: e.target.value,
                                    description: e.target.value,
                                    product_name: e.target.value,
                                  },
                                  index,
                                )
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        <>{item.name}</>
                      )}
                    </>
                  ) : (
                    <React.Fragment>
                      <DcDiv style={{ color: `${$DCprimaryColor}` }}>
                        {item.name}
                      </DcDiv>
                    </React.Fragment>
                  )}
                </ProductName>
                <ProductDescription>{item.sku}</ProductDescription>
              </Col>
            </Row>
          )}
          {item.product_id === -1 && (
            <Row>
              <Col style={{ width: '100%' }}>
                <DcDiv style={{ paddingLeft: '0px' }}>
                  <DcInput
                    isShowLabel={false}
                    required
                    type={'text'}
                    name={'name'}
                    as={'typeahead'}
                    labelKey={'product_name'}
                    data={products}
                    placeholder={'Search product'}
                    handleSearch={handleSearch}
                    formatter={(option) => {
                      return (
                        <DcDiv
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                          }}
                        >
                          <CustomTitle>
                            {option.custom && (
                              <>
                                <PixelIcon
                                  fontSize="14px"
                                  icon={faCirclePlus}
                                />
                                Add Custom Item
                              </>
                            )}
                          </CustomTitle>
                          <ProductContainer justify>
                            <DcDiv
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                gap: '10px',
                                whiteSpace: 'normal',
                              }}
                            >
                              {option.product_id !== 0 && (
                                <DcDiv>
                                  <ProductImage
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      borderRadius: '50%',
                                      objectFit: 'cover',
                                      marginRight: '10px',
                                    }}
                                    path={option.image}
                                  />
                                </DcDiv>
                              )}

                              <DcDiv>
                                <Address color="primary">
                                  {option.product_name} &nbsp;
                                  {option.custom && <>({option.custom})</>}
                                </Address>
                                <Address>sku : {option.sku}</Address>
                                <Address>
                                  Price: <PixelCurrency value={option.price} />
                                  &nbsp; &nbsp; Stock: {option.stock_quantity}
                                </Address>
                              </DcDiv>
                            </DcDiv>
                          </ProductContainer>
                        </DcDiv>
                      )
                    }}
                    onChange={(array) => {
                      if (array.length === 0) {
                        return
                      }
                      const obj = {
                        image: array[0].image,
                        name: array[0].product_name,
                        price: array[0].price,
                        quantity: 1,
                        product_id: array[0].product_id,
                        sku: array[0].sku,
                        tax: array[0].tax || 0,
                        variation_id: array[0].variation_id,
                        weight: array[0].weight,
                        total: array[0].price,
                      }

                      handleAddProduct(obj)
                    }}
                  />
                </DcDiv>
              </Col>
            </Row>
          )}
        </Col>
      </LineInfoItem>
      <PixelFlexBox width="48%" justifyContent="space-around">
        <DcFlexBox style={{ marginRight: '40px' }} width="15%">
          {editing ? (
            <DcDiv style={{ minWidth: '75px' }}>
              <DcInput
                isShowLabel={false}
                placeholder="Qty"
                type={'number'}
                onKeyDown={handleNegativePrice}
                min={0}
                noPadding
                value={item.quantity}
                disabled={item.product_id === -1}
                onChange={(e) => {
                  updateItem(
                    {
                      ...item,
                      quantity: e.target.value,
                      total: parseFloat(e.target.value) * item.price,
                    },
                    index,
                  )
                }}
              />
            </DcDiv>
          ) : (
            <DcFlexBox justifyContent="center">{item.quantity}</DcFlexBox>
          )}
        </DcFlexBox>
        <LineInfoItem noRow width="20%">
          {editing ? (
            <>
              <DcDiv style={{ minWidth: '100px' }}>
                <DcInput
                  noPadding
                  isShowLabel={false}
                  type={'number'}
                  placeholder="Price"
                  disabled={item.product_id === -1}
                  onKeyDown={handleNegativePrice}
                  min={0}
                  value={item.price}
                  onChange={(e) => {
                    updateItem(
                      {
                        ...item,
                        price: e.target.value,
                        total: e.target.value * item.quantity,
                      },
                      index,
                    )
                  }}
                />
              </DcDiv>
            </>
          ) : (
            <>
              <PixelCurrency value={item.price} />
            </>
          )}
        </LineInfoItem>
        <LineInfoItem style={{ marginRight: '10px' }} noRow width="20%">
          <PixelCurrency value={item.quantity * item.price} />
        </LineInfoItem>
      </PixelFlexBox>
    </LineItemRow>
  )
}

const LineItemActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 50px;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  display: none;
  background: ${colors.grayVeryLight};
  box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px 5px;
`

const LineItemRow = styled.div<{ is_deleted?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;

  width: 100%;
  padding: 10px;
  min-height: 110px;
  position: relative;
  &:hover {
    ${LineItemActions} {
      display: flex;
      flex-direction: row;
      width: 15%;
      height: 42px;

      z-index: 10;
    }
  }
  ${({ is_deleted }) =>
    is_deleted &&
    css`
      position: relative;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 7%;
        height: 39%;
        cursor: not-allowed;
        z-index: 10;
      }
      ${LineItemActions} {
        z-index: 20;
      }
    `}
`
const LineItemAction = styled.div<{ color?: string }>`
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${colors.grayLight};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: ${(props) => props.color};
  column-gap: 10px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  &:hover {
    background: ${(props) => props.color};
    color: ${colors.white};
    font-size: 15px;
  }
`
const LineInfoItem = styled.div<{ width?: string; noRow?: boolean }>`
  display: inline-flex;
  flex-direction: ${({ noRow }) => (noRow ? 'column' : 'row')};
  justify-content: flex-start;
  align-items: stretch;
  gap: 20px;
  align-content: stretch;

  width: ${(props) => props.width};
`

const ProductName = styled.div`
  font-size: 14px;
  color: ${colors.black};
  white-space: break-spaces;
`
const ProductDescription = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${colors.black};
  /* padding:0 0 0 10px; */
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
`
const Col = styled.div`
  display: inline-flex;
  flex-direction: column;
`

const ProductContainer = styled.div<{ justify?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.justify ? 'flex-start' : 'space-around'};
  align-items: center;
  align-content: center;
  width: 100%;
  padding: 5px;
`

const Address = styled.div<{ color?: string }>`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) =>
    props.color === 'primary' ? $DCprimaryColor : 'rgba(0, 0, 0, 0.87)'};
`
const CustomTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${$DCprimaryColor};
  margin-bottom: 10px;
`

const DeleteButton = styled.button`
  background: ${colors.grayVeryLight};
  border: none;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${colors.grayLight};
  }

  &:active {
    color: ${colors.white};
  }
`

const DeleteButtonText = styled.span`
  color: ${colors.black};
  font-size: 12px;
  font-weight: 500;
`

export default LineItem
